import React from 'react';

/**
 * The share button.
 *
 * There used to be a preview of the share text above it, but the emoji grid
 * took enough height on a phone to squeeze the leaderboard out of view.
 */
const ShareCard = ({ onShare }) => (
  <div className="summary-share">
    <button type="button" className="summary-share-button" onClick={onShare}>
      Share
    </button>
  </div>
);

export default ShareCard;
